import React from "react";
import { useAtom } from "jotai";
import { networkStatusAtom } from "../../AtomStore/store";
import Disconnect from "../../Pages/components/assets/pictures/disconnect.png";
import useNetworkStatus from "../useNetworkStatus";

const NetworkError = ({ retry }) => {
  const [isOnline] = useAtom(networkStatusAtom);
  useNetworkStatus();
  if (isOnline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center bg-white bg-opacity-70 z-9 ">
      <img src={Disconnect} alt="disconnected" className="mb-4" />
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-red-300">Network Error</h2>
        <p className="mb-2 p-4">
          It seems you are disconnected from the internet. Please check your
          connection.
        </p>
        <button
          onClick={retry}
          className="bg-header font-semibold text-white px-4 py-2 rounded hover:bg-blue-600 transition"
        >
          Retry
        </button>
      </div>
    </div>
  );
};

export default NetworkError;
